import {
  ShiftsResponse as Response,
  ShiftData,
  ShiftQueryParams,
  convertScheduleChangeToShiftData,
} from '@nextforce/api'
import { useQuery } from '@tanstack/react-query'
import { useServer } from 'app/server/context'
import keys from './shared/keys'

export function useShift(params: ShiftQueryParams, enabled = true) {
  const { server } = useServer()
  return useQuery<ShiftData>({
    queryKey: keys.detail(params),
    queryFn: fetchShift,
    enabled: enabled && params && ('id' in params || 'uri' in params),
  })

  async function fetchShift() {
    return convertScheduleChangeToShiftData(
      await server.get<Response.ScheduleChange>(getUrl(params))
    )
  }
}

function getUrl(params: ShiftQueryParams): string {
  let url = '/v2/schedule/changes'

  if (!params) {
    return url
  }

  if ('id' in params) {
    url += '/' + params.id

    if (params.view) {
      url += '?view=' + params.view
    }
  } else if ('uri' in params) {
    url = decodeURIComponent(params.uri!)
  } else {
    throw new Error('Invalid shift parameters')
  }
  return url
}
